// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","895":"component---src-templates-page-tsx"}[chunkId] + "-" + {"218":"77c746028a8621f8cd53","895":"c53d785a67689d580aa9"}[chunkId] + ".js";
};